import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const TechnicianService = {
    list: async () => axios.get(API_URL + "/technicians/list").then(({data}) => data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_URL + "/technicians/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (model) => axios.post(API_URL + "/technicians", model).then(({data}) => data).catch((err) => { throw err }),

    edit: async (model, id) => axios.post(API_URL + "/technicians/" + id, model).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/technicians/" + id).then(({data}) => data).catch((err) => { throw err })
};

export default TechnicianService;